// package imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// project imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const MasterFileDownload = lazy(
  () => import('pages/masterFileDownload/masterFileDownload')
);
const MasterDownloadRoute = (
  <Route
    index
    path={routeName.masterFileDownload}
    element={
      <PrivateRoute name={PrivateRouteConst.MASTER_FILE_DOWNLOAD}>
        <Suspense
          fallback={
            <div>
              <Loading />
            </div>
          }
        >
          <MasterFileDownload />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default MasterDownloadRoute;
